export default [
  {
    id: 0,
    name: ["Web development &", "UX/UI projects"],
    category: "my-work",
  },
  {
    id: 1,
    name: ["Research &", "Publications"],
    category: "research-and-publications",
  },
  {
    id: 2,
    name: ["Design", "Work"],
    category: "design-work",
  },
];



// WEBPACK FOOTER //
// ./src/routing/Navigation.js